import { message } from 'antd'
import { useState } from 'react'
import { changeHousePriority, changeStickyStatus } from '../../../../api/api'

const IsSticky = (props) => {
  const [is_sticky, setis_sticky] = useState(props.info.is_sticky)
  const info = props.info
  // console.log('isSticky', info)
  const changeStatus = () => {
    const params = {
      thread_ids: [info.id],
      is_sticky: info.is_sticky === 0 ? 1 : 0,
    }
    changeStickyStatus(params).then((res) => {
      console.log(res)
      setis_sticky((pre)=>{
        return pre === 0 ? 1 :0
      })
      is_sticky === 0
        ? message.success('置顶帖子成功！！')
        : message.success('取消置顶帖子成功！！')

        props.setIsFresh((pre) => {
          console.log(pre);
          return !pre
        })
    }).catch(
      err=> {
        console.warn(err);
        message.error('置顶帖子失败！')
      }
    )
  }

  return (
    <div>
      <a onClick={changeStatus}>{props.info.is_sticky === 0 ? '置顶' : '取消置顶'}</a>
    </div>
  )
}

export default IsSticky
